<template>
  <div class="pa-10">
    <v-card class="mt-2">
      <v-row class="">
        <v-col cols="12">
          <StudentFindHTEDataTable />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import StudentFindHTEDataTable from "@/components/Utils/StudentFindHTEDataTable.vue";
export default {
  components: {
    StudentFindHTEDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
